





















































































import IntegrityTable, {
  FillFunctionContainer,
  processDateWithTableObject,
} from '@/components/IntegrityTable/IntegrityTable.vue';
import UserPermissionsMixin from '@/components/UserPermissions/UserPermissionsMixin.vue';
import { UserPermission } from '@/store/userpermissions/types';
import { AssignmentActions } from '@/store/assignments/actions';
import { ReadyForCodingAssignmentData } from '@/store/assignments/types';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { uuid } from 'vue-uuid';
import util from '@/components/Report/util';
import { ProjectListing } from '@/store/project/types';
import { ProjectActions } from '@/store/project/actions';
import hasRedzoneEmail from '@/common/utils/UserUtils';

const assignmentsModule = namespace('assignments');
const userPrefsModule = namespace('userPrefs');
const projectModule = namespace('project');

@Component({
  components: {
    IntegrityTable,
  },
})
export default class Reporting extends UserPermissionsMixin {
  @assignmentsModule.Action(AssignmentActions.GET_READY_FOR_CODING_ASSIGNMENTS)
  getRFCAssignments;

  @assignmentsModule.State('readyForCodingAssignmentData')
  readyForCodingAssignmentData: ReadyForCodingAssignmentData[];

  @userPrefsModule.State('displayImperial') displayImperial: boolean;

  @projectModule.Action(ProjectActions.FETCH_ALL_PROJECTS_DATA) fetchAllProjectsData;

  @projectModule.State('allProjectsData') allProjects: ProjectListing[] | undefined;

  search = '';

  headers = [
    {
      text: 'Asset Name',
      value: 'assetName',
      sortable: true,
      filterable: true,
      class: 'sticky',
      cellClass: 'sticky',
    },
    {
      text: '',
      align: 'center',
      sortable: false,
      filterable: false,
      value: 'guid',
      class: 'sticky',
      cellClass: 'sticky',
    },
    {
      text: 'Asset Type',
      value: 'assetType',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Project Number',
      value: 'projectNumber',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Project Name',
      value: 'projectName',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Task',
      value: 'workOrderTask',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Inspection Date',
      value: 'inspectionDate',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Feedback',
      value: 'feedback',
      sortable: true,
      filterable: false,
    },
  ];

  matchFilters = [
    {
      header: 'assetName',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'guid',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'assetType',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'projectNumber',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'projectName',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'workOrderTask',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'inspectionDate',
      type: 'date',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'feedback',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
  ];

  get fillTableDataFunctions(): FillFunctionContainer {
    const returnValue: FillFunctionContainer = {
      updateKey: uuid.v4(),
      fillFunctions: [
        {
          headerValue: 'inspectionDate',
          functionVariables: ['inspectionDate'],
          fillFunction: processDateWithTableObject,
        },
      ],
    };
    return returnValue;
  }

  /**
   * Keeps track of the data being displayed on the deployment table.
   */
  tableData = [];

  mounted(): void {
    if (!this.hasPermissionReportingCommon) {
      this.goToErrorPage();
    }
    this.getRFCAssignments();
    this.fetchAllProjectsData();
  }

  uniqueValues(value: string, index: number, arr: string[]): boolean {
    return arr.indexOf(value) === index;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAssetParams(item: ReadyForCodingAssignmentData): any {
    return { idList: JSON.stringify([item.projectGuid]), id: item.guid };
  }

  /**
   * @returns true if the user has the permission REPORTING_COMMON
   */
  get hasPermissionReportingCommon(): boolean {
    return this.hasPermission(UserPermission.REPORTING_COMMON);
  }

  /**
   * Get list of codable readyForCodingAssignmentData items
   * @returns {ReadyForCodingAssignmentData[]}
   */
  get codableAssets(): ReadyForCodingAssignmentData[] {
    if (this.$auth.user !== null && hasRedzoneEmail(this.$auth.user.email)) {
      return this.readyForCodingAssignmentData ?? [];
    }

    let assets = [];
    let userProjects = [];

    if (this.allProjects) {
      userProjects = this.allProjects.map((p) => p.guid);

      if (this.readyForCodingAssignmentData) {
        assets = this.readyForCodingAssignmentData.filter(
          (e) => userProjects.includes(e.projectGuid),
        );
      }
    }

    return assets ?? [];
  }

  /**
   * Get list of assets with given assetType
   * @param {ReadyForCodingAssignmentData[]} assets List of assets
   * @param {string} assetType asset type to filter by
   * @returns {ReadyForCodingAssignmentData[]} list of filtered assets
   */
  filterAssetsByType(
    assets: ReadyForCodingAssignmentData[],
    assetType: string,
  ): ReadyForCodingAssignmentData[] {
    return assets?.filter((x) => x.assetType === assetType) ?? [];
  }

  /**
   * Get the total count of manholes in list of assets
   * @param {ReadyForCodingAssignmentData[]} assets List of assets
   * @returns {string} total manholes
   */
  manholeCount(assets: ReadyForCodingAssignmentData[]): string {
    return (
      this.filterAssetsByType(assets, 'Manhole').length ?? 0
    ).toLocaleString();
  }

  /**
   * Get the total sum of assetLength from all line segments
   * @param {ReadyForCodingAssignmentData[]} assets List of assets
   * @returns {string} sum of line segment's lengths
   */
  lineSegmentCount(assets: ReadyForCodingAssignmentData[]): string {
    const value = this.filterAssetsByType(assets, 'Line Segment').reduce(
      (a, b) => a + b.assetLength,
      0,
    ) ?? 0;
    if (!value) {
      return '0';
    }
    return util
      .getDisplayDistanceFtM(
        this.displayImperial,
        Math.round(value + Number.EPSILON),
      )
      .toLocaleString();
  }

  /**
   * Get count of codable manholes
   * @returns {string} number of codable manholes
   */
  get codableManholes(): string {
    return this.manholeCount(this.codableAssets);
  }

  /**
   * Get total length of all codable line segments
   * @returns {string} sum of codable line segment's lengths
   */
  get codableFootage(): string {
    return this.lineSegmentCount(this.codableAssets);
  }

  /**
   * Get count of filtered codable manholes
   * @returns {string} number of filtered codable manholes
   */
  get filteredCodableManholes(): string {
    return this.manholeCount(this.tableData);
  }

  /**
   * Get total length of all filtered codable line segments
   * @returns {string} sum of filtered codable line segment's lengths
   */
  get filteredCodableFootage(): string {
    return this.lineSegmentCount(this.tableData);
  }

  /**
   * Get appropriate label for feet or meters
   * @returns {string} 'ft' or 'm'
   */
  get distanceUnitsFtM(): string {
    return util.getDistanceUnitsFtM(this.displayImperial);
  }

  updateTableData(data: unknown[]): void {
    this.tableData = data;
  }
}
